import { render, staticRenderFns } from "./skudetail.vue?vue&type=template&id=c1dc6f6e&"
import script from "./skudetail.vue?vue&type=script&lang=js&"
export * from "./skudetail.vue?vue&type=script&lang=js&"
import style0 from "./skudetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports